import { Api } from '../axios-config'
import { ICliente } from '../cliente/ClienteService'

export interface IUsuario_Cliente {
    idUsuario: number;
    cnpj: string;
}

const getByIdUsuario = async (idUsuario: number): Promise<ICliente[] | Error> => {
    try {
        const { data } = await Api.get(`Usuario_cliente/pesquisar/clientesPorUsuarios?idUsuario=${idUsuario}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}
const create = async (objeto: IUsuario_Cliente) => {
    try {
        const { data } = await Api.post('Usuario_cliente', objeto);

        if (data) {
            return data;
        }

        return new Error('Erro ao cadastrar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao cadastrar os registros');
    }
}

export const Usuario_Cliente_Service = {
    getByIdUsuario,
    create
}